var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "sub_title" },
        [
          _c(
            "div",
            [
              _vm._v("\n      Beneficiary Information\n      "),
              _c(
                "el-tooltip",
                { attrs: { placement: "top" } },
                [
                  _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                    _vm._v(
                      "\n          1. Please ensure that the beneficiary's account is true, accurate, and\n          carefully distributed;"
                    ),
                    _c("br"),
                    _vm._v(
                      "2. After the Rep is minted successfully, it will\n          be automatically sent to the beneficiary's account according to the ratio you\n          set.\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("svg-icon", { attrs: { "icon-class": "ts" } }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.shareList.length < 10
            ? _c(
                "el-button",
                { attrs: { type: "text" }, on: { click: _vm.handleAdd } },
                [
                  _c("svg-icon", { attrs: { "icon-class": "share_add" } }),
                  _vm._v("\n      Add new beneficiary\n    "),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        { attrs: { data: _vm.shareList } },
        [
          _c("el-table-column", {
            attrs: { label: "No.", align: "center", width: "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.address === _vm.$store.getters.metaMaskObj.account
                      ? _c("svg-icon", {
                          attrs: { "icon-class": "share_user" },
                        })
                      : _vm._e(),
                    _vm._v(
                      "\n        " + _vm._s(scope.$index + 1) + "\n        "
                    ),
                    scope.row.address === _vm.$store.getters.metaMaskObj.account
                      ? _c("span", [_vm._v("(YOU)")])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "address", label: "Beneficiar" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("el-input", {
                      attrs: {
                        disabled:
                          row.address ===
                          _vm.$store.getters.metaMaskObj.account,
                      },
                      model: {
                        value: row.address,
                        callback: function ($$v) {
                          _vm.$set(row, "address", $$v)
                        },
                        expression: "row.address",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "ratio", label: "Benefit ratio", width: "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "el-input",
                      {
                        attrs: {
                          disabled:
                            row.address ===
                            _vm.$store.getters.metaMaskObj.account,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.getOwnRatio(row)
                          },
                        },
                        model: {
                          value: row.ratio,
                          callback: function ($$v) {
                            _vm.$set(row, "ratio", _vm._n($$v))
                          },
                          expression: "row.ratio",
                        },
                      },
                      [_c("template", { slot: "append" }, [_vm._v("%")])],
                      2
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { width: "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.address !== _vm.$store.getters.metaMaskObj.account
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text", icon: "el-icon-delete" },
                            on: {
                              click: function ($event) {
                                return _vm.handleDel(scope.$index)
                              },
                            },
                          },
                          [_vm._v("Delete")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }